<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    coverArea?: string;
    zIndex?: number;
  }>(),
  {
    coverArea: 'fixed',
    zIndex: 1999
  }
);

const coverArea = ref<string>(props.coverArea ? props.coverArea : 'absolute');
const showPopup = defineModel<boolean>('showPopup');

const emit = defineEmits<{
  (e: 'close-popup', showPopup: boolean): void;
}>();

/**
 * 關閉彈窗
 */
const closePopup = () => {
  showPopup.value = false;
  emit('close-popup', showPopup.value);
};

watch(
  () => showPopup.value,
  () => {
    if (showPopup.value) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }
);
</script>

<template>
  <div class="popup-card" v-if="showPopup" @click="closePopup">
    <slot></slot>
  </div>
</template>

<style scoped lang="scss">
.popup-card {
  position: v-bind(coverArea);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #00000066;
  z-index: v-bind(zIndex);
}
</style>
